import { render, staticRenderFns } from "./CustomerMoodReport.vue?vue&type=template&id=643e445b&scoped=true"
import script from "./CustomerMoodReport.vue?vue&type=script&lang=js"
export * from "./CustomerMoodReport.vue?vue&type=script&lang=js"
import style0 from "./CustomerMoodReport.vue?vue&type=style&index=0&id=643e445b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643e445b",
  null
  
)

export default component.exports